import axios from 'axios'
import Limit from '@/dto/limits/Limit'

const LimitsService = {
  loadLimits(): Promise<Limit[]> {
    return axios.get(`/admin/limits`).then(response => response.data.limits)
  },
  saveLimit(limit: Limit): Promise<Limit> {
    const request = limit.id
      ? axios.put(`/admin/limits/${limit.id}`, limit)
      : axios.post('/admin/limits', limit)

    return request.then(response => response.data.limit)
  },
  deleteLimit(limitId: number) {
    return axios.delete(`/admin/limits/${limitId}`)
  },
}

export default LimitsService
